import { Component, OnInit, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Payment, Transaction } from '../../models';
import { AuthService } from '../../services/auth.service';
import { PayService } from '../../services/pay.service';
import { BevalidaTransaction } from '../../models/bevalida-transaction';
import { AlertService } from '../../services/alert.service';
import { Summary } from '../../models/summary';
import { PurchaseService } from '../../services/purchase.service';
import { Country } from '../../models/country';
import { TokenServiceService } from '../../services/token-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CURRENCIE2COUNTRY } from '../../../assets/strings/translations';
import { ALERT_ERRORS, WALLET_VALIDATIONS } from '../../core/constants/Errors';
import { EmailValidator } from '../../tools/email-validator';
import { LEGAL_FILES } from '../../core/constants/URLs';
import { CONSTANTS } from '../../constants/users.constants';
import { environment } from 'src/environments/environment';
import { createMerchantReturnUrl } from 'src/app/shared/helps/helps';
import { AUTOCOMPLETE_METHOD_PAY_TYPES, FLAGS_NAME, } from 'src/app/core/constants/General-constants';
import { PatchValAdditionalInfoService } from 'src/app/services/patch-val-additional-info.service';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { MatDialog } from '@angular/material/dialog';
import { WalletDialogComponent } from './wallet-dialog/wallet-dialog.component';

@Component({
    selector: 'app-wallet',
    templateUrl: './wallet.component.html',
    styleUrls: ['./wallet.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WalletComponent implements OnInit {
    @Input() info: Payment;
    @Output() WALLET = new EventEmitter();

    listCountries: Country[];
    orderID: string;
    transaction: Transaction;
    summary: Summary;
    walletTransaction: BevalidaTransaction;
    loading: boolean = true;
    urlReturnMerchant: string;
    template: string;
    form: FormGroup;
    iframeHeight: string = '100%';
    errorsMessages = WALLET_VALIDATIONS;
    personalDataURL = LEGAL_FILES.PERSONAL_DATA;
    urlWalletSignUp = environment.urlWalletSignUp;
    urlWalletRecoverPass = environment.urlWalletRecoverPass;
    urlWalletSignUpString = 'Crear una cuenta';
    urlWalletRecoverPassString = '¿Olvidaste tu contraseña?';
    formPrivacyValid: boolean = false;
    isEditableInfo: boolean = false;
    useEmebbedWallet: boolean = false;
    walletEmebbedUrl: string = environment.urlWalletLogin;
    walletsAutoCompleteFF: boolean = false;
    objectControlData = [
        {
            formControl: 'country',
            readonly: false,
        },
        {
            formControl: 'email',
            readOnly: false,
        },
    ];

    constructor(
        private readonly authService: AuthService,
        private readonly payService: PayService,
        private readonly alertService: AlertService,
        private readonly router: Router,
        private readonly purchaseService: PurchaseService,
        private readonly tokenServiceService: TokenServiceService,
        private readonly formBuilder: FormBuilder,
        private readonly patchValAdditionalInfoService: PatchValAdditionalInfoService,
        private readonly featureFlagService: PayvalidaFeatureFlagService,
        private readonly dialog: MatDialog
    ) {
        this.form = this.formBuilder.group({
            ip: [''],
            country: ['', Validators.min(1)],
            email: ['', Validators.compose([Validators.required, EmailValidator.isValid, Validators.maxLength(150)])],
            pass: ['', Validators.required],
            token: ['', Validators.required],
        });
    }

    async ngOnInit() {
        // TODO https://dev.azure.com/payvalida/payValida/_workitems/edit/23678

        this.loading = true;
        this.onActivate();
        this.template = this.info.template;
        this.walletTransaction = new BevalidaTransaction();
        this.orderID = this.authService.getOrderID();
        this.transaction = this.tokenServiceService.getAndDecodeToken();
        this.walletTransaction.token = this.tokenServiceService.getToken();
        this.urlReturnMerchant = createMerchantReturnUrl(this.orderID, this.transaction.MERCHANT_URL_RETURN);

        this.form.patchValue(this.walletTransaction);

        this.useEmebbedWallet = await this.featureFlagService.getFeatureFlagValue(this.orderID, FLAGS_NAME.PAYVALIDA_WALLET_EMBEBED).toPromise()

        if (this.useEmebbedWallet) {
            this.dialog.open(WalletDialogComponent, {
                width: '95%',
                maxWidth: '100%',
                enterAnimationDuration: '0',
                disableClose: false,
                panelClass: 'wallet-iframe-dialog',
                hasBackdrop: true,
                data: {
                    info: this.info,
                    changeMethod: this.changeMethod,
                    url: environment.urlWalletLogin + '?ref=' + this.transaction.ORDER_REFERENCE,
                }
            }).backdropClick().subscribe(() => this.changeMethod());

            return this.loading = false;
        }

        this.purchaseService.countryList().subscribe((data: any) => {
            if (data.CODE === CONSTANTS.CODE_OK) {
                this.loading = false;

                this.listCountries = data.DATA.filter((c) => c.NAME === CURRENCIE2COUNTRY[this.transaction.ORDER_CURRENCY]);

                if (this.listCountries) {
                    this.walletTransaction.country = this.listCountries.find((c) => c.NAME === CURRENCIE2COUNTRY[this.transaction.ORDER_CURRENCY]).CODE;

                    const additionalInfo = this.tokenServiceService.exitsAdditionalInformation(this.transaction);

                    if (additionalInfo) {
                        return this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.WALLETS_AUTOCOMPLETE_FF, FLAGS_NAME.WALLETS_AUTOCOMPLETE_FF).subscribe((response: boolean) => {
                            this.walletsAutoCompleteFF = response;

                            if (this.walletsAutoCompleteFF) this.disabledItems(additionalInfo);
                        });
                    }

                    this.form.patchValue(this.walletTransaction);
                }
            } else {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.TRANSACTION_ERROR, 'warning');
                this.changeMethod();
            }
        });
    }

    /**
    *
    * @description {isControlReadOnly} function to check if form fields are read-only
    * @param controlName
    * @returns
    */
    isControlReadOnly(controlName: string): boolean {
        const readOnlyControl = this.objectControlData.find((m) => m.formControl === controlName);

        return readOnlyControl ? readOnlyControl.readOnly : false;
    }

    /**
    *
    * @description {disabledItems} Function to disabled items to checkout form
    */
    disabledItems(additionalInfo) {
        try {
            this.isEditableInfo = this.tokenServiceService.isEditableInfo(additionalInfo);

            return this.patchValAdditionalInfoService.patchValAdditionalInfo(
                this.isEditableInfo,
                additionalInfo,
                this.form,
                AUTOCOMPLETE_METHOD_PAY_TYPES.WALLETS,
                this.objectControlData,
                null,
                null,
                this.walletTransaction.country
            );
        } catch (_) {
            this.alertService.showAlert(ALERT_ERRORS.GET_TOKEN_DATA_ERROR);
        }
    }

    async processPayment() {
        try {
            const response: any = await this.payService.beValidaTransaction(this.walletTransaction);
            this.loading = false;
            if (response.CODE === CONSTANTS.CODE_OK) {
                this.summary = response.DATA;
                this.authService.setSummary(this.summary);
                await this.router.navigate(['checkout/alertBE']);
            } else {
                this.alertService.showAlert(response.TEXT, 'warning');
            }
        } catch (e) {
            this.loading = false;
            this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
        }
    }

    /**
     *
     * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
     * @param valid
     */
    formPrivacyUpdate = (valid: boolean) => {
        this.formPrivacyValid = valid;
    };
    /**
     *
     * @description {completedForms} Function to validate the validations of the parent component and child component
     * @returns
     */
    completedForms = (): boolean => {
        return this.form.valid && this.formPrivacyValid;
    };

    /**
     * @description Function that validates the payment form
     */
    async validData() {
        this.loading = true;
        this.walletTransaction = this.form.value;
        this.walletTransaction.country = Number(this.walletTransaction.country);

        if (this.completedForms()) {
            this.walletTransaction.tyc = true;
            await this.processPayment();
        } else {
            this.loading = false;
            this.alertService.showAlert(ALERT_ERRORS.DATA_IMCOMPLETED, 'warning');
        }
    }

    changeMethod() {
        this.WALLET.emit();
    }

    onActivate() {
        window.scroll(0, 0);
    }
}